const permissions = localStorage.getItem('permissions') && JSON.parse(localStorage.getItem('permissions'));

export const RolePermission = (neededPermissions) => {
    const userPermission = []

    permissions && permissions.map((i) => userPermission.push({code: i}))

    if (neededPermissions?.length) {
        const uniqSet = new Set()
        neededPermissions?.forEach((permissions) => uniqSet.add(permissions))

        for (let i of userPermission) {
            if (i?.code === 0) {
                return true
            } else if (uniqSet.has(i?.code)) {
                return true
            }
        }
    } else {
        return false
    }
}



